<template>
  <Transition name="slide-down">
    <div
      v-if="!online"
      class="offline-banner"
      role="status"
      aria-live="polite"
    >
      You're offline. Changes will sync when you reconnect.
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useOffline } from "@/composables/useOffline"

const { online } = useOffline()
</script>

<style scoped>
.offline-banner {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 10000;
  padding: 0.5rem 1rem;
  background: var(--ion-color-warning);
  color: var(--ion-color-warning-contrast);
  font-size: 0.875rem;
  font-weight: 600;
  text-align: center;
  padding-top: max(0.5rem, env(safe-area-inset-top));
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 200ms ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
}
</style>
